"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.number.is-integer");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _device_salesorder = require("@/api/device_salesorder");
var _device = require("@/api/device");
var _org = require("@/api/org");
var _indexFormList = _interopRequireDefault(require("./components/indexFormList.vue"));
var _user = require("@/api/user");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultDeviceSalesOrder = {
  device_model: '',
  quantity: '',
  device_attr: 1,
  device_attributes: '',
  amount: '',
  equipment_owner: '',
  receiving_medical_no: '',
  // receiving_medical_type: 1,
  pre_shipment_time: '',
  device_type: 1,
  sales: '',
  sales_name: '',
  device_range: 2,
  remark: ''
};
var defalutApproval = {
  approval_status: null,
  approval_remark: ''
};
var defalutShipment = {
  receiving_medical_name: null,
  receiving_medical_addr: null,
  receiving_medical_contact: null,
  receiving_medical_phone: null,
  // receiving_medical_type: '',
  shipment_time: null,
  courier_company: null,
  shipment_no: null,
  devices: [],
  devices1: '',
  quantity: null,
  receiving_remark: ''
};
var checkNumber = function checkNumber(rule, value, callBack) {
  if (!Number.isInteger(value)) {
    callBack(new Error('请输入合法的整数值'));
  } else {
    if (value < 0) {
      callBack(new Error('数量不能小于0'));
    } else {
      callBack();
    }
  }
};
var checkNumber1 = function checkNumber1(rule, value, callBack) {
  if (!Number(value * 1) && value * 1 !== 0) {
    callBack(new Error('请输入合法的数值'));
  } else {
    if (value * 1 < 0) {
      callBack(new Error('金额不能小于0'));
    } else {
      callBack();
    }
  }
};
var _default = exports.default = {
  components: {
    TransformList: _indexFormList.default
  },
  data: function data() {
    return {
      listLoading: true,
      listLoading1: true,
      tableData: {
        count: 0
      },
      devicesalesorder: defaultDeviceSalesOrder,
      deviceapproval: defalutApproval,
      deviceshipment: defalutShipment,
      dialogVisible: false,
      approvalDialog: false,
      dialogTransformLoading: false,
      viewDialog: false,
      transformData: {
        results: []
      },
      shipmentDialog: false,
      adminDialog: false,
      dialogType: 'new',
      number: '',
      rule1: {
        device_attributes: [{
          required: true,
          message: '请选择设备分类',
          trigger: 'change'
        }],
        device_model: [{
          required: true,
          message: '请选择设备型号',
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          message: '请输入设备数量',
          trigger: 'blur'
        }, {
          validator: checkNumber
        }],
        amount: [{
          required: true,
          message: '请输入订单金额',
          trigger: 'blur'
        }, {
          validator: checkNumber1
        }],
        receiving_medical_no: [{
          required: true,
          message: '请输入收货医疗机构编号',
          trigger: 'blur'
        }],
        equipment_owner: [{
          required: true,
          message: '请选择设备归属人',
          trigger: 'change'
        }],
        // receiving_medical_type: [{ required: true, message: '请选择收货医疗机构类型', trigger: 'change' }],
        pre_shipment_time: [{
          required: true,
          message: '请输入预发货时间',
          trigger: 'blur'
        }],
        sales: [{
          required: true,
          message: '请输入销售员编码',
          trigger: 'blur'
        }],
        sales_name: [{
          required: true,
          message: '非法人员请重新输入编码',
          trigger: 'blur'
        }],
        device_range: [{
          required: true,
          message: '请选择使用范围',
          trigger: 'change'
        }],
        remark: [{
          max: 200,
          message: '输入长度不能超过200位',
          trigger: 'blur'
        }]
      },
      rule2: {
        approval_status: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        approval_remark: [{
          max: 200,
          message: '输入长度不能超过200位',
          trigger: 'blur'
        }]
      },
      rule3: {
        receiving_medical_addr: [{
          required: true,
          message: '请输入收货医疗机构地址',
          trigger: 'blur'
        }],
        receiving_medical_contact: [{
          required: true,
          message: '请输入收货医疗机构联系人',
          trigger: 'blur'
        }],
        receiving_medical_phone: [{
          required: true,
          message: '请输入收货医疗机构联系人电话',
          trigger: 'blur'
        }],
        // receiving_medical_type: [{ required: true, message: '请选择收货医疗机构类型', trigger: 'change' }],
        receiving_medical_name: [{
          required: true,
          message: '请输入收货医疗机构名称',
          trigger: 'blur'
        }],
        shipment_time: [{
          required: true,
          message: '请输入发货时间',
          trigger: 'blur'
        }],
        courier_company: [{
          required: true,
          message: '请输入快递公司',
          trigger: 'blur'
        }],
        shipment_no: [{
          required: true,
          message: '请输入发货单号',
          trigger: 'blur'
        }],
        devices1: [{
          required: true,
          message: '请输入发货设备编号',
          trigger: 'blur'
        }],
        receiving_remark: [{
          max: 200,
          message: '输入长度不能超过200位',
          trigger: 'blur'
        }]
      },
      rule4: {
        devices1: [{
          required: true,
          message: '请输入发货设备编号',
          trigger: 'blur'
        }]
      },
      statusOptions: [{
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '待发货'
      }, {
        value: 3,
        label: '拒绝'
      }, {
        value: 4,
        label: '完成'
      }],
      listQuery: {
        page: 1,
        page_size: 10
      },
      attrOptions: [{
        value: 1,
        label: '购买'
      }, {
        value: 2,
        label: '赠送'
      }, {
        value: 3,
        label: '试用机'
      }, {
        value: 4,
        label: '其它'
      }],
      typeOptions: [{
        value: 1,
        label: '2.1版'
      }, {
        value: 2,
        label: '2.0版'
      }, {
        value: 3,
        label: '2.2版'
      }, {
        value: 4,
        label: '非医有调理码'
      }, {
        value: 5,
        label: '非医无调理码'
      }],
      approvalOptions: [{
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '拒绝'
      }],
      approvalOptions1: [{
        value: 2,
        label: '通过'
      }, {
        value: 3,
        label: '拒绝'
      }, {
        value: 4,
        label: '通过'
      }],
      deviceOption: [{
        key: 1,
        label: '一般设备'
      }, {
        key: 2,
        label: '控释盘'
      }],
      confirmOptions: [{
        key: 1,
        label: '收货机构'
      }, {
        key: 2,
        label: '渠道通用'
      }],
      deviceList: [],
      orgList: [],
      deviceModelList: [],
      devices: '',
      userData: [],
      devicelog_lists: [],
      receiving_medical_name: '',
      receiving_medical_addr: '',
      receiving_medical_contact: '',
      receiving_medical_phone: '',
      user_id: '',
      userList: []
    };
  },
  created: function created() {
    this.getList();
    this.getDeviceModelList();
    this.getUserList();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.listQuery.page_size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.listQuery.page = val;
      this.getList();
    },
    checkPermission: _permission.default,
    handleAdd: function handleAdd() {
      var _this = this;
      this.devicesalesorder = Object.assign({}, defaultDeviceSalesOrder);
      this.receiving_medical_name = '';
      this.receiving_medical_addr = '';
      this.receiving_medical_contact = '';
      this.receiving_medical_phone = '';
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs['Form'].clearValidate();
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _device_salesorder.getDeviceSalesOrderAll)(this.listQuery).then(function (response) {
        if (response.data) {
          // console.log(response.data)
          _this2.tableData = response.data;
        }
        _this2.listLoading = false;
      });
    },
    getUserList: function getUserList() {
      var _this3 = this;
      (0, _user.getUserList)().then(function (response) {
        if (response.data) {
          (0, _user.getUserList)({
            page: 1,
            page_size: response.data.count
          }).then(function (res) {
            _this3.userData = (0, _utils.genTree)(res.data.results);
            console.log(_this3.userData);
          });
        }
      });
    },
    getDeviceModelList: function getDeviceModelList() {
      var _this4 = this;
      (0, _device.getDeviceModelList)().then(function (response) {
        _this4.deviceModelList = response.data;
        // console.log(this.deviceModelList)
      });
    },
    getName: function getName() {
      var _this5 = this;
      console.log(this.devicesalesorder.receiving_medical_no);
      if (this.devicesalesorder.receiving_medical_no !== '') {
        this.listQuery.dept_no = this.devicesalesorder.receiving_medical_no;
        (0, _org.getOrgList)(this.listQuery).then(function (response) {
          if (response.data[0]) {
            console.log(response.data);
            _this5.receiving_medical_name = response.data[0].name;
            _this5.receiving_medical_addr = response.data[0].province_name + response.data[0].city_name + response.data[0].district_name + response.data[0].addrs;
            if (response.data[0].charge_name) {
              (0, _user.getUser)(response.data[0].charge_name).then(function (res) {
                _this5.receiving_medical_contact = res.data.name;
              });
            } else {
              _this5.receiving_medical_contact = '';
            }
            // this.receiving_medical_contact = response.data[0].charge_name
            _this5.receiving_medical_phone = response.data[0].charge_contact;
            (0, _user.getQuqaoUser)({
              dept_id: response.data[0].id,
              commission_id: 3
            }).then(function (response1) {
              _this5.userList = response1.data;
            });
          } else {
            _this5.receiving_medical_name = '';
            _this5.receiving_medical_addr = '';
            _this5.receiving_medical_contact = '';
            _this5.receiving_medical_phone = '';
            _this5.userList = [];
          }
        });
      } else {
        this.receiving_medical_name = '';
        this.receiving_medical_addr = '';
        this.receiving_medical_contact = '';
        this.receiving_medical_phone = '';
        this.userList = [];
      }
      console.log(this.receiving_medical_name);
    },
    getName1: function getName1() {
      var _this6 = this;
      console.log(this.devicesalesorder.receiving_medical_no);
      if (this.devicesalesorder.receiving_medical_no !== '') {
        this.listQuery.dept_no = this.devicesalesorder.receiving_medical_no;
        (0, _org.getOrgList)(this.listQuery).then(function (response) {
          if (response.data) {
            console.log(response.data);
            _this6.deviceshipment.receiving_medical_name = response.data[0].name;
            _this6.deviceshipment.receiving_medical_addr = response.data[0].province_name + response.data[0].city_name + response.data[0].district_name + response.data[0].addrs;
            (0, _user.getUser)(response.data[0].charge_name).then(function (res) {
              _this6.deviceshipment.receiving_medical_contact = res.data.name;
            });
            // this.deviceshipment.receiving_medical_contact = response.data[0].charge_name
            _this6.deviceshipment.receiving_medical_phone = response.data[0].charge_contact;
          } else {
            _this6.devicesalesorder.receiving_medical_name = '';
            _this6.devicesalesorder.receiving_medical_addr = '';
            _this6.devicesalesorder.receiving_medical_contact = '';
            _this6.devicesalesorder.receiving_medical_phone = '';
          }
        });
        console.log(this.devicesalesorder.receiving_medical_name);
      } else {
        this.devicesalesorder.receiving_medical_name = '';
        this.devicesalesorder.receiving_medical_addr = '';
        this.devicesalesorder.receiving_medical_contact = '';
        this.devicesalesorder.receiving_medical_phone = '';
      }
    },
    getSaleName: function getSaleName() {
      var _this7 = this;
      console.log(this.devicesalesorder.sales);
      if (this.devicesalesorder.sales) {
        (0, _user.getUserList)({
          user_id: this.devicesalesorder.sales
        }).then(function (response) {
          if (response.data.results) {
            if (response.data.results[0].commission_branches === '新汉方公司') {
              console.log(1, response.data);
              _this7.$set(_this7.devicesalesorder, 'sales_name', response.data.results[0].username);
              // this.devicesalesorder.sales_name = response.data.results[0].username
              _this7.user_id = response.data.results[0].id;
            } else {
              _this7.devicesalesorder.sales_name = '';
            }
          } else {
            _this7.devicesalesorder.sales_name = '';
          }
        });
      } else {
        this.devicesalesorder.sales_name = '';
      }
      console.log(this.devicesalesorder.sales_name);
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(scope) {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.devicesalesorder = Object.assign({}, scope.row); // copy obj
              this.user_id = this.devicesalesorder.sales;
              if (!this.devicesalesorder.sales) {
                _context.next = 5;
                break;
              }
              _context.next = 5;
              return (0, _user.getUser)(this.devicesalesorder.sales).then(function (response) {
                _this8.$set(_this8.devicesalesorder, 'sales', response.data.user_id);
                _this8.$set(_this8.devicesalesorder, 'sales_name', response.data.username);
              });
            case 5:
              console.log(this.devicesalesorder);
              this.getName();
              this.dialogType = 'edit';
              this.dialogVisible = true;
              this.$nextTick(function () {
                _this8.$refs['Form'].clearValidate();
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleDelete: function handleDelete(scope) {
      var _this9 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _device_salesorder.deleteDeviceSalesOrder)(scope.row.id);
            case 2:
              // this.tableData.splice($index, 1)
              _this9.getList();
              _this9.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleView: function handleView(scope) {
      this.transformData.results = [];
      this.viewDialog = true;
      this.devicesalesorder = Object.assign({}, scope.row);
      this.transformData.results.push(this.devicesalesorder);
      console.log(this.transformData);
    },
    handleApproval: function handleApproval(scope) {
      var _this10 = this;
      this.devicesalesorder = Object.assign({}, scope.row);
      this.deviceapproval = Object.assign({}, defalutApproval);
      this.getName();
      this.approvalDialog = true;
      this.$nextTick(function () {
        _this10.$refs['approvalForm'].clearValidate();
      });
    },
    handleShipment: function handleShipment(scope) {
      var _this11 = this;
      this.devicesalesorder = Object.assign({}, scope.row);
      this.deviceshipment = Object.assign({}, defalutShipment);
      this.deviceshipment.quantity = scope.row.quantity;
      this.getName1();
      this.shipmentDialog = true;
      this.$nextTick(function () {
        _this11.$refs['shipmentForm'].clearValidate();
      });
    },
    handleAdminEdit: function handleAdminEdit(scope) {
      var _this12 = this;
      this.devicesalesorder = Object.assign({}, scope.row);
      this.deviceList = scope.row.device_lists;
      this.devicelog_lists = scope.row.devicelog_lists;
      console.log(this.deviceList);
      this.devices = '';
      // this.deviceshipment.receiving_medical_type = scope.row.receiving_medical_type
      this.deviceshipment.receiving_medical_addr = scope.row.receiving_medical_addr;
      this.deviceshipment.receiving_medical_contact = scope.row.receiving_medical_contact;
      this.deviceshipment.receiving_medical_phone = scope.row.receiving_medical_phone;
      this.deviceshipment.receiving_medical_name = scope.row.receiving_medical_name;
      this.deviceshipment.shipment_time = scope.row.shipment_time;
      this.deviceshipment.shipment_no = scope.row.shipment_no;
      this.deviceshipment.courier_company = scope.row.courier_company;
      this.adminDialog = true;
      this.$nextTick(function () {
        _this12.$refs['adminForm'].clearValidate();
      });
      this.listLoading1 = false;
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(form) {
        var _this13 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this13.dialogType === 'edit';
                  if (isEdit) {
                    _this13.devicesalesorder.sales = _this13.user_id;
                    delete _this13.devicesalesorder.sales_name;
                    _this13.devicesalesorder.status = 1;
                    (0, _device_salesorder.updateDeviceSalesOrder)(_this13.devicesalesorder.id, _this13.devicesalesorder).then(function (res) {
                      _this13.getList();
                      _this13.dialogVisible = false;
                      _this13.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    }).catch(function (error) {
                      console.log(2, error);
                      (0, _user.getUser)(_this13.devicesalesorder.sales).then(function (response) {
                        _this13.$set(_this13.devicesalesorder, 'sales', response.data.user_id);
                        _this13.$set(_this13.devicesalesorder, 'sales_name', response.data.username);
                      });
                      console.log(_this13.devicesalesorder);
                    });
                  } else {
                    _this13.devicesalesorder.sales = _this13.user_id;
                    delete _this13.devicesalesorder.sales_name;
                    (0, _device_salesorder.createDeviceSalesOrder)(_this13.devicesalesorder).then(function (res) {
                      _this13.getList();
                      _this13.dialogVisible = false;
                      _this13.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    }).catch(function (error) {
                      console.log(2, error);
                      (0, _user.getUser)(_this13.devicesalesorder.sales).then(function (response) {
                        _this13.$set(_this13.devicesalesorder, 'sales', response.data.user_id);
                        _this13.$set(_this13.devicesalesorder, 'sales_name', response.data.username);
                      });
                      console.log(_this13.devicesalesorder);
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function confirm(_x2) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    confirmApproval: function () {
      var _confirmApproval = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(form) {
        var _this14 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _device_salesorder.approvalDeviceSalesOrder)(_this14.devicesalesorder.id, _this14.deviceapproval).then(function (response) {
                    if (_this14.deviceapproval.approval_status === 1) {
                      _this14.getList();
                      _this14.approvalDialog = false;
                      _this14.$message({
                        message: '审核通过',
                        type: 'success'
                      });
                    } else if (_this14.deviceapproval.approval_status === 2) {
                      _this14.getList();
                      _this14.approvalDialog = false;
                      _this14.$message({
                        message: '审核拒绝',
                        type: 'danger'
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function confirmApproval(_x3) {
        return _confirmApproval.apply(this, arguments);
      }
      return confirmApproval;
    }(),
    confirmShipment: function () {
      var _confirmShipment = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(form) {
        var _this15 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  _this15.devices = _this15.deviceshipment.devices1;
                  _this15.deviceshipment.devices = _this15.devices.split(',');
                  delete _this15.deviceshipment.devices1;
                  console.log(_this15.deviceshipment);
                  (0, _device_salesorder.shipmentDeviceSalesOrder)(_this15.devicesalesorder.id, _this15.deviceshipment).then(function (res) {
                    _this15.shipmentDialog = false;
                    _this15.getList();
                    _this15.$message({
                      message: '发货成功',
                      type: 'success'
                    });
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function confirmShipment(_x4) {
        return _confirmShipment.apply(this, arguments);
      }
      return confirmShipment;
    }(),
    confirmAdmin: function () {
      var _confirmAdmin = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(form) {
        var _this16 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  _this16.devices = _this16.deviceshipment.devices1;
                  _this16.deviceshipment.devices = _this16.devices.split(',');
                  delete _this16.deviceshipment.devices1;
                  console.log(_this16.deviceshipment);
                  (0, _device_salesorder.shipmentDeviceSalesOrder)(_this16.devicesalesorder.id, _this16.deviceshipment).then(function (response) {
                    _this16.$set(_this16.deviceshipment, 'devices1', '');
                    console.log(_this16.deviceshipment);
                    _this16.$nextTick(function () {
                      _this16.$refs['adminForm'].clearValidate();
                    });
                    _this16.getList();
                    _this16.$message({
                      message: '发货成功',
                      type: 'success'
                    });
                  });
                  _this16.devices = '';
                  _this16.listLoading1 = true;
                  setTimeout(function () {
                    (0, _device_salesorder.getDeviceSalesOrder)(_this16.devicesalesorder.id).then(function (res) {
                      _this16.deviceList = res.data.device_lists;
                      _this16.devicelog_lists = res.data.devicelog_lists;
                      _this16.listLoading1 = false;
                    });
                  }, 1000);
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function confirmAdmin(_x5) {
        return _confirmAdmin.apply(this, arguments);
      }
      return confirmAdmin;
    }(),
    handleDeleteAdmin: function handleDeleteAdmin(scope) {
      var _this17 = this;
      console.log(scope.row.device_number);
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return (0, _device_salesorder.deleteDevice)(_this17.devicesalesorder.id, {
                devices: [scope.row.device_number]
              });
            case 2:
              _this17.listLoading1 = true;
              (0, _device_salesorder.getDeviceSalesOrder)(_this17.devicesalesorder.id).then(function (res) {
                _this17.deviceList = res.data.device_lists;
                _this17.devicelog_lists = res.data.devicelog_lists;
                _this17.listLoading1 = false;
              });
              _this17.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))).catch(function (err) {
        console.error(err);
      });
    }
  }
};